<template>
  <div class="price-highway" v-loading="importLoading">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: priceType === 0 }">运输线路价格</div>
      <div @click="typeFun(1)" class="right" :class="{ active: priceType === 1 }">港口作业单价</div>
    </div>
    <div class="nav" v-if="priceType === 0">
      <el-form :model="form" label-width="80px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="合同名称:">
          <el-input placeholder="请输入合同名称" size="mini" v-model="form.contractName"></el-input>
        </el-form-item>
        <el-form-item label="合同编号:">
          <el-input v-model="form.contractCode" size="mini" placeholder="请输入合同编号"></el-input>
        </el-form-item>
        <el-form-item label="委托商:">
          <el-input placeholder="请输入委托商" size="mini" v-model="form.customerName"></el-input>
        </el-form-item>
        <el-form-item label="起始地:">
          <el-input placeholder="请输入起始地" size="mini" v-model="form.startAddressName"></el-input>
        </el-form-item>
        <el-form-item label="目的地:">
          <el-input placeholder="请输入目的地" size="mini" v-model="form.endAddressName"></el-input>
        </el-form-item>
        <el-form-item label="运输方式:">
          <el-select v-model="form.transportType" filterable size="mini" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="公路" value="1"></el-option>
            <el-option label="水路" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式:">
          <el-select v-model="form.type" filterable size="mini" placeholder="请选择结算方式">
            <el-option label="全部" value=""></el-option>
            <el-option label="合同 " value="0"></el-option>
            <el-option label="预结算" value="1"></el-option>
            <el-option label="预估" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型:">
          <el-input placeholder="请输入车型" size="mini" v-model="form.customerCarName"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" filterable size="mini" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待生效" value="0"></el-option>
            <el-option label="生效中" value="1"></el-option>
            <el-option label="已失效" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入人员:">
          <el-input placeholder="请输入录入人员" size="mini" v-model="form.createByName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
          <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
          <el-button size="small" type="primary" @click="motorcycleTypeFormat">车型格式</el-button>
          <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
          <el-button size="small" class="resetBtn" @click="onClickStips">批量停用</el-button>
          <!-- <el-button size="small" type="primary" >导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="content" v-if="priceType === 0">
      <div class="tableContainer">
        <div style="display: flex; justify-content: flex-end">
          <span class="el-icon-download el-icon--right" style="cursor: pointer; font-size: 16px; margin-right: 20px; color: rgba(51, 136, 255, 1); display: flex; align-items: center" @click="download">模板下载</span>
          <span style="cursor: pointer; margin-right: 20px">
            <el-upload ref="upload" class="upload-demo" style="color: rgba(51, 136, 255, 1)" :action="uploadUrl" :auto-upload="true" :show-file-list="false" :data="uploadData" :on-success="planOnSuccess" :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
          <span style="cursor: pointer; font-size: 16px; color: rgba(51, 136, 255, 1)" @click="exportData">导出数据</span>
        </div>
        <!-- :selectable='(row)=>{return row.status === 0}' -->
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop="contractName" label="合同名称" show-overflow-tooltip min-width="150" align="center" />
          <el-table-column prop="contractCode" label="合同编号" show-overflow-tooltip min-width="150" align="center" />
          <el-table-column prop="customerName" label="委托商" show-overflow-tooltip width="150" align="center" />
          <el-table-column prop="transportType" label="运输方式" show-overflow-tooltip align="center">
            <template slot-scope="scope">{{ scope.row.transportType | transportTypeFormat }} </template>
          </el-table-column>
          <el-table-column label="起始地" width="280" align="center">
            <template slot-scope="scope">
              <!--              <span-->
              <!--                :style="{'paddingRight':(scope.row.startPort?'30px':'0px')}">{{ scope.row.startAddressName-->
              <!--                }}</span>-->
              <!--              <i v-if='scope.row.startPort' class='port-icon' :title='scope.row.startPort'>港</i>-->
              {{ `${scope.row.startAddressName}  ${scope.row.startPort ? '【' + scope.row.startPort + '】' : ''}` }}
            </template>
          </el-table-column>
          <el-table-column label="目的地" width="280" align="center">
            <template slot-scope="scope">
              <!--              <span-->
              <!--                :style="{'paddingRight':(scope.row.endPort?'30px':'0px')}">{{ scope.row.endAddressName-->
              <!--                }}</span>-->
              <!--              <i v-if='scope.row.endPort' class='port-icon' :title='scope.row.endPort'>港</i>-->
              {{ `${scope.row.endAddressName}  ${scope.row.endPort ? '【' + scope.row.endPort + '】' : ''}` }}
            </template>
          </el-table-column>
          <el-table-column prop="customerCarName" label="车型" show-overflow-tooltip min-width="120" align="center" />
          <!-- <el-table-column prop="isPerfectPrice" label="是否完善合同" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">{{scope.row.isPerfectPrice==1?'是':'否'}}</template>
          </el-table-column> -->
          <el-table-column prop="taxRate" label="税率%" show-overflow-tooltip align="center" />
          <el-table-column prop="contractPrice" label="合同单价" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              {{ scope.row.contractPrice != 0 ? scope.row.contractPrice : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="preparePrice" label="预结算单价" show-overflow-tooltip width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.preparePrice ? (scope.row.preparePrice != 0 ? scope.row.preparePrice : '') : scope.row.isPerfectPrice == 1 ? '--' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="estimatePrice" label="预估单价" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              {{ scope.row.estimatePrice != 0 ? scope.row.estimatePrice : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip width="150" align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column prop="createByName" label="录入人员" show-overflow-tooltip width="150" align="center" />
          <el-table-column prop="startDate" label="开始时间" show-overflow-tooltip width="100" align="center">
            <template slot-scope="scope">{{ scope.row.startDate | getTime }}</template>
          </el-table-column>
          <el-table-column prop="end_date" label="结束时间" show-overflow-tooltip width="100" align="center">
            <template slot-scope="scope">{{ scope.row.endDate | getTime }}</template>
          </el-table-column>
          <el-table-column prop="status" label="状态" show-overflow-tooltip align="center">
            <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
          </el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情 </el-button>
                <el-button v-if="scope.row.status === 0 || scope.row.status === 1" :loading="scope.row.editBtnLoading" size="mini" type="primary" @click="changeClick(scope.row.id, scope.row.status, scope.row.createByName, scope.row)" class="yellow-bg">
                  {{ scope.row.status === 0 ? '修改' : '修改车型' }}
                </el-button>
                <el-button v-if="scope.row.status === 0" size="mini" type="primary" @click="enableClick(scope.row)">启用 </el-button>
                <el-button v-if="scope.row.status === 1" size="mini" type="danger" @click="stopClick(scope.row)">停用 </el-button>
                <!--                <el-button size="mini" class="yellow-bg" type="danger" @click="recordBtn(scope.row)"-->
                <!--                  >补录合同-->
                <!--                </el-button>-->
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除 </el-button>
                <!--                <el-button v-if="scope.row.status=== 1"-->
                <!--                           size='mini' type='primary'-->
                <!--                           @click='changePriceOpenDialog(scope.row)'>修改金额-->
                <!--                </el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 20px">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="form.page" :page-size="form.rows" />
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="800px" center>
      <div class="detail">
        <div class="baseInfo" v-loading="detailDialogLoad">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
            <p>{{ detailData.status | statusFormat }}</p>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData" label-position="left">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="委托商:">
                    <span>{{ detailData.customer_name }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同名称:">
                    <span>{{ detailData.contract_name }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同编号:">
                    <span>{{ detailData.contract_Code }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="线路名称:">
                    <span>{{ detailData.line_name }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="运输方式:">
                    <span>{{ detailData.transport_type | transportTypeFormat }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="起始地:">
                    <span v-if="!detailData.startPortId">{{ detailData.startPosition }}</span>
                    <span v-else>{{ detailData.startPosition }}【{{ detailData.startPort }}】</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="交车地:">
                    <span v-if="!detailData.endPortId">{{ detailData.endPosition }}</span>
                    <span v-else>{{ detailData.endPosition }}【{{ detailData.endPort }}】</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="有效期始:">
                    <span>{{ detailData.start_date | getTime }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结束时间:">
                    <span>{{ detailData.end_date | getTime }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="baseInfoTitle">
            <div class="line" />
            <span>价格信息</span>
          </div>
          <div class="baseInfoContent">
            <el-form label-position="left">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="税率:">
                    <span>{{ detailData.tax_rate ? detailData.tax_rate + '%' : '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="合同价:">
                    <span>{{ detailData.contract_price ? detailData.contract_price + '元' : '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预结算价:">
                    <span>{{ detailData.prepare_price ? detailData.prepare_price + '元' : '无' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预估价:">
                    <span>{{ detailData.estimate_price ? detailData.estimate_price + '元' : '无' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="baseInfoTitle">
            <div class="line" />
            <span>补录合同</span>
          </div>
          <div class="baseInfoContent">
            <el-table
              :data="contractDataList"
              style="width: 100%"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '13px',
                height: '35px',
                background: '#E8E8E8',
              }"
              :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
              ref="carTableRef">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="codeNumber" label="合同编号" min-width="150" align="center" />
              <el-table-column prop="contractName" label="合同名称" min-width="150" align="center" />
              <el-table-column prop="typeName" label="合同类型" min-width="100" align="center" />
              <el-table-column prop="supplementaryContract.rate" label="税率" min-width="150" align="center" />
              <el-table-column prop="supplementaryContract.taxContractPrice" label="含税合同价" min-width="150" align="center" />
              <el-table-column prop="supplementaryContract.contractPrice" label="不含税合同价" min-width="150" align="center" />
              <el-table-column prop="startDate" label="开始日期" min-width="100" :formatter="getDate" align="center" />
              <el-table-column prop="endDate" label="结束日期" min-width="100" :formatter="getDate" align="center" />
              <el-table-column width="200px" label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="deleteTableClick(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="baseInfoTitle">
            <div class="line" />
            <span>适配车型</span>
          </div>
          <div class="baseInfoContent">
            <el-table
              :data="detailData.carModelList"
              style="width: 100%"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '13px',
                height: '35px',
                background: '#E8E8E8',
              }"
              :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
              ref="carTableRef">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column label="品牌" prop="brandName" align="center" />
              <el-table-column label="型号" prop="modelName" align="center" />
              <el-table-column label="状态" prop="status" align="center">
                <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
              </el-table-column>
            </el-table>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>操作信息</span>
            </div>
            <div class="operationTable">
              <el-table :data="detailData.operateRecordList" border :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B', height: '35px' }">
                <el-table-column prop="createTime" label="操作时间" align="center" width="160px" />
                <el-table-column prop="operateType" label="操作类型" align="center" />
                <el-table-column prop="operationName" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="dataD.showNumber === 1 ? '添加收入计费' : '修改收入计费'" :close-on-click-modal="false" :visible.sync="addflag" width="800px" center @close="dialogClose">
      <add @addclose="addshow" :addType="addType" :editType="editType" :dataD="dataD" ref="LinePriceAdd"></add>
    </el-dialog>
    <el-dialog title="车型格式" :close-on-click-modal="false" :visible.sync="carVisible" width="800px" center @close="dialogClose">
      <div style="margin: 10px">{{ carList }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="carVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="carVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 完善价格 -->
    <el-dialog title="完善价格" :visible.sync="priceSetVisible" :close-on-click-modal="false" append-to-body width="910px">
      <div style="padding: 20px">
        <div-border label="价格设置">
          <el-form :model="completeDate" label-width="100px">
            <el-form-item label="结算方式：" style="margin-top: 15px" v-if="completeDate.isWay != 1">
              <span style="display: inline-block; width: 320px">
                <el-radio-group v-model="completeDate.type">
                  <el-radio :label="0">暂无</el-radio>
                  <el-radio :label="1">合同价格</el-radio>
                  <el-radio v-if="completeDate.isWay == -1" :label="2">预结算价格</el-radio>
                </el-radio-group>
              </span>
              <span style="display: inline-block; width: calc(100% - 320px); text-align: right; padding-right: 15px">
                <el-input size="small" v-if="completeDate.type !== 0" v-model="completeDate.price" placeholder="请输入价格" />
              </span>
            </el-form-item>
            <el-form-item label="预估价：" v-if="completeDate.isEst" style="width: calc(100% - 250px); display: inline-block" :style="completeDate.isWay == 1 ? 'margin-top:15px;' : ''">
              <el-input size="small" v-model="completeDate.estimate" placeholder="请输入预估价" />
            </el-form-item>
            <el-form-item label-width="0px" style="width: 250px; text-align: right; display: inline-block" :style="!completeDate.isEst ? 'width:100%;' : ''">
              <el-button size="small" class="searchBtn" @click="priceSetConfirm">确定</el-button>
              <el-button size="small" class="resetBtn" @click="priceSetVisible = false">取消 </el-button>
            </el-form-item>
          </el-form>
        </div-border>
        <div-border :is-need="true" v-if="completeDate.isWay != 1 && completeDate.type != 0" label="选择合同" style="padding: 29px 20px">
          <div class="nav">
            <div class="navContainer">
              <p>合同名称：</p>
              <el-input v-model="condition.contractName" size="mini" style="width: 150px" placeholder="请输入合同名称" />
            </div>
            <div class="navContainer">
              <p>合同编号：</p>
              <el-input v-model="condition.codeNumber" size="mini" style="width: 150px" placeholder="请输入合同编号" />
            </div>
            <div class="navContainer">
              <p>签约单位：</p>
              <el-input v-model="condition.companyName" size="mini" style="width: 150px" placeholder="请输入签约单位" />
            </div>
            <div class="navBtn">
              <el-button size="small" class="searchBtn" @click="_contractPageList">查询</el-button>
              <el-button size="small" class="resetBtn" @click="resetComplete">重置</el-button>
            </div>
          </div>
          <el-table
            :data="contractData"
            highlight-current-row
            border
            ref="contractTable"
            @current-change="contractChange"
            v-loading="contractLoad"
            :header-cell-style="{
              color: '#3B3B3B',
              'font-weight': '700',
              padding: '0px',
              'font-size': '13px',
              height: '35px',
              background: '#E8E8E8',
            }"
            :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
            <el-table-column type="index" width="50" />
            <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
            <el-table-column property="contractName" label="合同名称" min-width="150" align="center" />
            <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
            <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
            <el-table-column property="startDate" label="开始日期" min-width="100" :formatter="getDate" align="center" />
            <el-table-column property="endDate" label="结束日期" min-width="100" :formatter="getDate" align="center" />
          </el-table>
          <div style="margin-top: 20px">
            <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="conditionTotal" @size-change="completeSizeChange" @current-change="completeCurrentChange" :current-page.sync="condition.page" :page-size="condition.rows" />
          </div>
        </div-border>
      </div>
    </el-dialog>
    <!--补录合同-->
    <el-dialog title="补录合同" :visible.sync="contractVisible" :close-on-click-modal="false" append-to-body width="910px" @close="cancel">
      <div-border label="价格设置">
        <div class="nav" style="margin-top: 10px">
          <div class="navContainer" style="width: 300px">
            <p style="width: 100px">不含税金额：</p>
            <el-input v-model.number="condition.price" size="mini" style="width: 150px" placeholder="请输入不含税金额" />
          </div>
          <div class="navContainer">
            <p>含税金额：</p>
            <el-input v-model.number="condition.taxPrice" size="mini" style="width: 150px" placeholder="请输入含税金额" />
          </div>
          <div class="navBtn" style="width: 200px">
            <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
            <el-button size="small" class="resetBtn" @click="cancel">取消</el-button>
          </div>
        </div>
      </div-border>
      <div-border label="选择合同">
        <el-table
          :data="contractTableData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          style="margin-top: 10px"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column property="contractName" label="合同名称" min-width="150" align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column property="startDate" label="开始日期" min-width="100" :formatter="getDate" align="center" />
          <el-table-column property="endDate" label="结束日期" min-width="100" :formatter="getDate" align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="contractTotal" @size-change="addContractSizeChange" @current-change="addContractCurrentChange" :current-page.sync="page" :page-size="row" />
        </div>
      </div-border>
    </el-dialog>
    <changePrice @success="searchBtn" ref="changePriceRef" />
    <!--港口作业单价设置-->
    <entrust v-if="priceType === 1" ref="entrustRef" />
  </div>
</template>

<script>
  import add from './add';
  import { lineConfigSelectOpt, lineConsignorLineList, lineConfigDetail, lineConfigStop, contractPageList, completePrice, lineConDelete, getCarModelList, getContractInfo, deleteContractInfo, getContractPageList, addContract } from '@/service/financial';
  import { publicSelectLine } from '@/service/vehiclelog';
  import { formatDateTime, formatTime, getSessionStore } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';
  import divBorder from '@/components/divBorder';
  import { baseUrl } from '@/config/env';
  import changePrice from '@/components/changePrice';
  import Entrust from '@/views/financial/price/entrust.vue';

  export default {
    components: {
      Entrust,
      add,
      divBorder,
      changePrice,
    },
    data() {
      return {
        detailDialogLoad: false,
        editBtnLoading: false,
        importLoading: false,
        priceType: 0, //0:运输线路价格设置 1:港口作业单价设置
        form: {
          customerName: '', // 供应商名称
          contractName: '', // 运输方式
          contractCode: '', // 适配车型
          startAddressName: '', //起运地
          endAddressName: '', //起运地
          customerCarName: '', //交车地
          transportType: '',
          createByName: '', // 录入人员
          status: '',
          page: 1,
          rows: 10,
          type: '',
        },
        tableLoad: false,
        TableDatas: [],
        carVisible: false,
        carList: '',
        activeName: 'basics',
        detailDialogVisible: false,
        lineOption: [],
        detailData: {
          state: '待生效',
          number: '1234567',
          referred: '民生物流1',
          type: '商务合同',
          company: '重庆什么dfsdfsdfsdfsdfdfsdfsdf公司',
          price: '12345666',
          tell: '02358600000',
          mail: '3150000000@qq.com',
          area: '重庆市-渝北区',
          address: '重庆市渝北区xxx',
          name: '张晓辉',
          nameTell: '17700000000',
          time: '2021-8-31 15:25:53',
          createMan: '李忘生',
          basicsData: [],
        },
        contractData: [],
        operationData: [],
        dialogTitle: '',
        DialogVisible: false,
        modifyflag: false,
        addflag: false,
        addType: false,
        //1 为添加，2为修改
        dataD: {
          showNumber: 1,
          user_id: '',
          data: {},
        },

        uploadUrl: '', //导入地址
        uploadData: { mFile: '' }, // 导入数据

        //修改金额
        dialogDetailVisible: false,
        dialogNames: '',
        changePriceId: '',

        // 完善价格
        priceSetVisible: false, // 弹窗显隐
        completeDate: {
          id: '',
          type: 0, // 结算方式
          price: '', // 价格
          estimate: '', // 预估价
        },
        // // 合同查询条件
        // condition: {
        //   codeNumber: '',   // 合同编号
        //   contractName: '',   // 合同名称
        //   companyName: '',    // 签约单位
        //   page: 1,
        //   rows: 10,
        // },
        conditionTotal: 0,
        contractDataList: [],
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        editType: 0,
        checkTableData: [],
        contractVisible: false,
        contractTableData: [],
        condition: {
          price: '',
          taxPrice: '',
        },
        contractTotal: 0,
        contractLoad: false,
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        row: 10,
      };
    },
    filters: {
      transportTypeFormat(value) {
        switch (value) {
          case 1:
            return '公路';
          case 2:
            return '水路';
        }
      },
      statusFormat(value) {
        switch (value) {
          case 0:
            return '待生效';
          case 1:
            return '生效中';
          case 2:
            return '已失效';
        }
      },
      typeFormat(value) {
        switch (value) {
          case 1:
            return '固定';
          case 2:
            return '比例';
        }
      },
      getTime(val) {
        if (val) {
          // return formatDateTime(val, "yyyy-mm-dd hh:ii:ss")
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    mounted() {
      this._publicSelectLine(1);
      this.$nextTick(() => {
        //  this._lineConsignorLineList();
      });
    },
    created() {
      this.uploadUrl = getImportUrl('/price/consignorLine/batchLinePrice');
    },
    methods: {
      // 运输线路价格设置/港口作业单价设置 切换
      typeFun(val) {
        this.priceType = val;
        this.$nextTick(() => {
          // this.searchBtn();
          this.TableDatas = [];
          this.total = 0;
        });
      },
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0) return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认要批量启用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            let res = await lineConfigStop({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      async _lineConsignorLineList() {
        this.tableLoad = true;
        let res = await lineConsignorLineList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        // if(res.data.records.length > 0) {
        //   res.data.records.forEach((item,index) => {
        //     this.lineOption.some(function(tem) {
        //       if (tem.id == item.lineId) {
        //         res.data.records[index] = {
        //           ...item,
        //           'startAddressName': tem.start_address_name,
        //           'endAddressName': tem.end_address_name,
        //         }
        //       }
        //     })
        //   })
        // }
        this.TableDatas = res.data.records;
        // console.log(111,this.TableDatas);
        this.total = res.data.total;
      },
      async _lineConfigSelectOpt() {
        let res = await lineConfigSelectOpt();
        if (res.status !== 0) return this.$message.error(res.message);
      },

      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 获取线路数据
      async _publicSelectLine(type) {
        let res = await publicSelectLine({ type: type });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
      },
      searchBtn() {
        this.form.page = 1;
        this._lineConsignorLineList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;
      },
      addBtn() {
        this.editType = 0;
        this.dataD.showNumber = 1;
        this.addType = false;
        this.addflag = true;
        this.$nextTick(() => {
          this.$refs.LinePriceAdd._publicSelectLine(1);
          this.$refs.LinePriceAdd._customerInfoSelectList();
          // this.$refs.LinePriceAdd._getCarSerieList()
        });
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._lineConsignorLineList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._lineConsignorLineList();
      },
      // 详情
      async detailClick(id) {
        this.detailDialogVisible = true;
        this.detailDialogLoad = true;
        let res = await lineConfigDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        // 运输线路
        let res1 = await publicSelectLine({ type: res.data.transport_type });
        if (res1.status !== 0) return this.$message.error(res1.message);
        if (res1.data.length > 0) {
          res1.data.forEach(item => {
            if (item.id == this.detailData.line_id) {
              this.detailData.startPosition = item.start_address_name;
              this.detailData.startPortId = item.departure_port_id;
              this.detailData.startPort = item.departure_port;
              this.detailData.endPosition = item.end_address_name;
              this.detailData.endPortId = item.arrive_port_id;
              this.detailData.endPort = item.arrive_port;
            }
          });
          let res2 = await getContractInfo(id);
          if (res2.status !== 0) return this.$message.error(res2.message);
          this.contractDataList = res2.data;
        }
        this.detailDialogLoad = false;
      },
      //详情-补录合同-删除
      deleteTableClick(row) {
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          let obj = {
            priceInfoId: row.supplementaryContract.priceInfoId,
            contractId: row.supplementaryContract.contractId,
            type: 1,
          };
          const res = await deleteContractInfo(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.detailDialogVisible = false;
        });
      },
      // 修改
      async changeClick(id, type, createByName, row) {
        row.editBtnLoading = true;
        this.editType = type;
        let res = await lineConfigDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.dataD.data = res.data;
        this.dataD.showNumber = 2;
        this.dataD.user_id = id;
        this.$nextTick(() => {
          this.$refs.LinePriceAdd._getCarSerieList();
          this.$refs.LinePriceAdd._customerInfoSelectList();
          this.$refs.LinePriceAdd.getDetail();
        });
        this.addType = false;
        row.editBtnLoading = false;
        this.addflag = true;

      },
      // 启用
      enableClick(row) {
        this.$confirm('确认要启用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: row.id,
              status: 1,
            };
            let res = await lineConfigStop(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      // 停用
      stopClick(row) {
        this.$confirm('确认要停用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: row.id,
              status: 2,
            };
            let res = await lineConfigStop(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStips() {
        // console.log(this.checkTableData);
        if (this.checkTableData.length > 0) {
          this.$confirm('确认要停用选中的线路价格吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData.id + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              let obj = {
                id: ids,
                status: 2,
              };
              let res = await lineConfigStop(obj);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.checkTableData = [];
              await this._lineConsignorLineList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用的路线价格！',
            type: 'warning',
          });
        }
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认要删除线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            console.log(id);
            let res = await lineConDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认要删除选中的线路价格吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              let res = await lineConDelete(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this._lineConsignorLineList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      //修改金额-打开对话框
      changePriceOpenDialog(row) {
        //调用子组件的方法打开对话框
        this.$refs.changePriceRef.dialogOpen(row.id, 1);
      },
      /**
       *  补录合同
       */
      recordBtn(row) {
        this.condition.id = row.id;
        this.companyId = row.customerId;
        (this.condition.rate = row.taxRate), (this.contractPrice = row.contractPrice);
        this.preparePrice = row.preparePrice;
        this.startDate = row.startDate;
        this.endDate = row.endDate;
        this.selectContract = '';
        this.getContractPage();
      },
      //查询
      async getContractPage() {
        let obj = {
          id: this.condition.id,
          companyId: this.companyId,
          contractPrice: this.contractPrice ? this.contractPrice : '',
          preparePrice: this.preparePrice ? this.preparePrice : '',
          page: this.page,
          row: this.row,
        };
        this.contractLoad = true;
        let res = await getContractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.contractVisible = false;
        } else {
          this.contractVisible = true;
          this.contractTableData = res.data.records;
          this.contractTotal = res.data.total;
        }
      },
      async contractConfirm() {
        if (!this.condition.price || this.condition.price === '') {
          return this.$message.warning('请输入不含税金额！');
        }
        if (!this.condition.taxPrice || this.condition.taxPrice === '') {
          return this.$message.warning('请输入含税金额！');
        }
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        let obj = {
          type: 1,
          rate: this.condition.rate,
          taxPrice: this.condition.taxPrice,
          price: this.condition.price,
          priceInfoId: this.condition.id,
          contractId: this.selectContract.id,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        const res = await addContract(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.contractVisible = false;
      },
      cancel() {
        this.condition.price = '';
        this.condition.taxPrice = '';
        this.contractVisible = false;
      },
      addContractSizeChange(rows) {
        this.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.page = page;
        this.getContractPage();
      },
      /**
       * 完善价格
       */
      // 完善价格 —— 打开弹窗
      complete(row) {
        this.condition.page = 1;
        this.completeDate = {
          id: row.id,
          isWay: row.isPerfectPrice,
          isEst: !row.estimatePrice,
          customerId: row.customerId,
          type: 0,
          price: '',
          estimate: row.estimatePrice || '',
        };
        if (row.isPerfectPrice == 0) this.completeDate.price = row.contractPrice;
        if (row.contractId) {
          this.selectContract = { id: row.contractId };
        } else {
          this.selectContract = '';
        }
        this.priceSetVisible = true;
        this._contractPageList();
      },
      // 完善价格 —— 合同分页查询
      async _contractPageList() {
        let obj = {
          ...this.condition,
          id: this.completeDate.customerId,
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractData = res.data;
        this.total = res.data.total || 0;
        if (this.selectContract.id && this.contractData.length > 0) {
          this.contractData.forEach(item => {
            if (item.id == this.selectContract.id) {
              if (this.$refs.contractTable) this.$refs.contractTable.setCurrentRow(item);
            }
          });
        }
      },
      // 完善价格 —— 重置
      resetComplete() {
        for (let key in this.condition) {
          if (key == 'page' || key == 'rows') continue;
          this.condition[key] = '';
        }
      },
      completeSizeChange(rows) {
        this.condition.rows = rows;
        this._contractPageList();
      },
      completeCurrentChange(page) {
        this.condition.page = page;
        this._contractPageList();
      },
      // 完善价格 —— 选中合同
      contractChange(val) {
        this.selectContract = val;
      },
      // 完善价格 —— 确认
      async priceSetConfirm() {
        if (this.completeDate.type == 1 && (!this.completeDate.price || this.completeDate.price == '')) {
          return this.$message.warning('请输入价格！');
        }
        if (this.completeDate.type == 1 && (!this.selectContract.id || this.selectContract.id == '')) {
          return this.$message.warning('请选择合同！');
        }
        let obj = '?id=' + this.completeDate.id;
        if (this.completeDate.isWay != 1 && this.completeDate.type == 1) {
          obj += '&contractId=' + this.selectContract.id;
          obj += '&contractPrice=' + this.completeDate.price;
        }
        if (this.completeDate.isWay == -1 && this.completeDate.type == 2) {
          obj += '&preparePrice=' + this.completeDate.price;
          if (this.selectContract.id && this.selectContract.id != '') {
            obj += '&contractId=' + this.selectContract.id;
          }
        }
        if (this.completeDate.isEst && this.completeDate.estimate) {
          obj += '&estimatePrice=' + this.completeDate.estimate;
        }
        let res = await completePrice(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this._lineConsignorLineList();
        this.priceSetVisible = false;
      },

      addshow(val) {
        this.addType = false;
        this.addflag = val;
        // this._lineConsignorLineList()
      },
      dialogClose() {
        this.$refs.LinePriceAdd.dialogClose();
      },
      handleClick() {},

      //模板下载
      download() {
        window.location.href = '/file/委托商运输线路价格导入模板.xlsx';
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._lineConsignorLineList();
          },
        });
      },
      beforeUpload(file) {
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      async motorcycleTypeFormat() {
        const { status, message, data } = await getCarModelList();
        if (status !== 0) return this.$message.warning(message);
        this.carList = data;
        this.carVisible = true;
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        const { customerName, contractName, contractCode, startAddressName, endAddressName, customerCarName, transportType, status, type } = this.form;
        // window.location.href = `${baseUrl}/platform/price/consignorLine/linePriceExport?access_token=${token}&customerName=${customerName}&contractName=${contractName}&contractCode=${contractCode}&startAddressName=${startAddressName}&endAddressName=${endAddressName}&customerCarName=${customerCarName}&transportType=${transportType}&status=${status}&type=${type}`;
        window.exportExcelGet('/platform/price/consignorLine/linePriceExport', `customerName=${customerName}&contractName=${contractName}&contractCode=${contractCode}&startAddressName=${startAddressName}&endAddressName=${endAddressName}&customerCarName=${customerCarName}&transportType=${transportType}&status=${status}&type=${type}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .price-highway {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      width: 100%;
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        form.el-form {
          margin-bottom: 15px;
        }

        label.el-form-item__label {
          font-size: 14px;
          color: #101010;
          height: 28px;
          line-height: 28px;
          font-weight: 400;
        }

        .el-form-item {
          margin-right: 10px;
          margin-bottom: 5px !important;
        }

        .el-form-item__content {
          height: 28px;
          line-height: 28px;
        }
      }
    }
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 239px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }

    ::v-deep .detail {
      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        .el-table td,
        .el-table th {
          padding: 0;
        }

        .el-table td .cell {
          font-weight: 400;
        }

        .cell {
          font-size: 10px;
          padding: 0;
          font-weight: 900;
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            margin-bottom: 10px !important;
            font-weight: 700;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          /*margin-top: 10px;*/
          padding: 20px;
        }
      }
    }
  }

  ::v-deep {
    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    span.el-icon-download.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-form--inline .el-form-item__label {
      font-weight: 400;
      color: #000;
    }

    // .el-dialog__headerbtn {
    //   // top: 9px;
    // }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-dialog__wrapper {
      top: -52px;
    }

    .el-form-item {
      margin-bottom: 10px !important;
      font-weight: 700;
    }

    td .el-button {
      margin: 3px !important;
    }

    .el-table .cell.el-tooltip span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      max-width: 160px;
    }

    .el-table td {
      padding: 0;
    }
  }

  .port-icon-td::v-deep {
    .cell {
      padding-right: 0px;
    }
  }

  i.port-icon {
    position: absolute;
    display: inline-block;
    left: 140px;
    // top: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 20px;
    background: red;
    color: #fff;
    border-radius: 50%;
  }

  .navBtn {
    display: inline-block;
    width: calc(100% - 690px);
    text-align: right;
    margin-bottom: 10px;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
